var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GlobalImportConfig_1;
/* eslint-disable import/export */
/* eslint-disable no-redeclare */
/* eslint-disable camelcase */
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ImportConfig, ImportConfigType } from './importConfig';
export var GlobalDataType;
(function (GlobalDataType) {
    GlobalDataType["SampleCustomers"] = "sampleCustomers";
    GlobalDataType["Adjustments"] = "adjustments";
    GlobalDataType["Commissions"] = "commissions";
    GlobalDataType["Payouts"] = "payouts";
    GlobalDataType["Transactions"] = "transactions";
    GlobalDataType["Forecasting"] = "forecasting";
    /** Diversity of employees */
    GlobalDataType["Diversity"] = "diversity";
    GlobalDataType["SellerPerformance"] = "sellerPerformance";
    GlobalDataType["GenderPay"] = "genderPay";
    /** Employee attrition for Seller Churn app */
    GlobalDataType["SellerChurn"] = "sellerChurn";
    GlobalDataType["SellerChurnTest"] = "sellerChurnTest";
    /** Diversity of candidates for hiring */
    GlobalDataType["DiversityCandidates"] = "diversityCandidates";
    GlobalDataType["LeadScoring"] = "leadScoring";
    GlobalDataType["SellerCapacity"] = "sellerCapacity";
    // Note: SellerCapacityPerformance DEPRECATED. used for db consistency
    GlobalDataType["SellerCapacityPerformance"] = "sellerCapacityPerformance";
    GlobalDataType["SmartMatcherTransactionsTrain"] = "smartMatcherTransactionsTrain";
    GlobalDataType["SmartMatcherLookupTrain"] = "smartMatcherLookupTrain";
    GlobalDataType["SmartMatcherTransactionsTest"] = "smartMatcherTransactionsTest";
    GlobalDataType["SmartMatcherLookupTest"] = "smartMatcherLookupTest";
    GlobalDataType["Benchmarking"] = "benchmarking";
    GlobalDataType["OneColumnOneRow"] = "oneColumnOneRow";
    GlobalDataType["CombinationMatcherData"] = "combinationMatcherData";
    GlobalDataType["CombinationMatcherValidCombination"] = "combinationMatcherValidCombination";
    GlobalDataType["FinancialAdvisorTurnoverTrain"] = "financialAdvisorTurnoverTrain";
    GlobalDataType["FinancialAdvisorTurnoverTest"] = "financialAdvisorTurnoverTest";
    GlobalDataType["CustomerLifetimeValueSMBRevenue"] = "customerLifetimeValueSMBRevenue";
    GlobalDataType["CustomerLifetimeValueMMRevenue"] = "customerLifetimeValueMMRevenue";
    GlobalDataType["CustomerLifetimeValueEnterpriseRevenue"] = "customerLifetimeValueEnterpriseRevenue";
    GlobalDataType["DealValueChangesCRMOpportunities"] = "dealValueChangesCRMOpportunities";
    GlobalDataType["DiscountingDiagnosticsOrders"] = "discountingDiagnosticsOrders";
    GlobalDataType["DiscountingDiagnosticsIndustryBenchmarks"] = "discountingDiagnosticsIndustryBenchmarks";
    GlobalDataType["DiscountingDiagnosticsDealSizeBenchmarks"] = "discountingDiagnosticsDealSizeBenchmarks";
    GlobalDataType["ASC606PrepBaseCommission"] = "asc606PrepBaseCommission";
    GlobalDataType["ASC606PrepTransactionCredits"] = "asc606PrepTransactionCredits";
    GlobalDataType["ASC606PrepTransactionMaster"] = "asc606PrepTransactionMaster";
    GlobalDataType["ASC606TransactionalCommissions"] = "asc606TransactionalCommissions";
    GlobalDataType["ASC606DateString"] = "asc606DateString";
    GlobalDataType["ASC606AmortizationSetup"] = "asc606AmortizationSetup";
    GlobalDataType["OpportunityScores"] = "opportunityScores";
    GlobalDataType["RosterValidationICM"] = "rosterValidationICM";
    GlobalDataType["RosterValidationSP"] = "rosterValidationSP";
    // START: deprecated
    GlobalDataType["OrderValidationOrders"] = "orderValidationOrders";
    GlobalDataType["OrderValidationValidOrders"] = "orderValidationValidOrders";
    GlobalDataType["OrderValidationTransactions"] = "orderValidationTransactions";
    // END: deprecated
    GlobalDataType["OrderConsolidationOrders"] = "orderConsolidationOrders";
    GlobalDataType["OrderConsolidationValidOrders"] = "orderConsolidationValidOrders";
    GlobalDataType["RecordAndAdjustmentCurrentPeriodTransactions"] = "recordAndAdjustmentCurrentPeriodTransactions";
    GlobalDataType["RecordAndAdjustmentPriorPeriodTransactions"] = "recordAndAdjustmentPriorPeriodTransactions";
    GlobalDataType["IdentifyNewHiresAllEmployees"] = "identifyNewHiresAllEmployees";
    GlobalDataType["IdentifyNewHiresNewHires"] = "identifyNewHiresNewHires";
    GlobalDataType["TrackTerritoryChangesCurrentCycle"] = "trackTerritoryChangesCurrentCycle";
    GlobalDataType["TrackTerritoryChangesPreviousCycle"] = "trackTerritoryChangesPreviousCycle";
    GlobalDataType["TransactionReconciliationBillingData"] = "transactionReconciliationBillingData";
    GlobalDataType["TransactionReconciliationOrders"] = "transactionReconciliationOrders";
    GlobalDataType["TransactionValidationTransactions"] = "transactionValidationTransactions";
    GlobalDataType["EntityResolutionAccountLookup"] = "entityResolutionAccountLookup";
    GlobalDataType["EntityResolutionTransactions"] = "entityResolutionTransactions";
    GlobalDataType["HierarchyCreationAccountList"] = "hierarchyCreationAccountList";
    GlobalDataType["HierarchyCreationUSStatesCode"] = "hierarchyCreationUSStatesCode";
    GlobalDataType["HierarchyValidatorCustomerAccounts"] = "hierarchyValidatorCustomerAccounts";
    // Note: Used for consistency with QA environment as discountingDiagnostics blueprint
    // has been updated.
    GlobalDataType["DiscountingDiagnosticsOverall"] = "discountingDiagnosticsOverall";
    GlobalDataType["DiscountingDiagnostics0_1000"] = "discountingDiagnostics0_1000";
    GlobalDataType["DiscountingDiagnostics1001_5000"] = "discountingDiagnostics1001_5000";
    GlobalDataType["FuzzyMatcherCustomerLookup"] = "fuzzyMatcherCustomerLookup";
    GlobalDataType["FuzzyMatcherSurveyResults"] = "fuzzyMatcherSurveyResults";
    GlobalDataType["HotelBookings"] = "hotelBookings";
    GlobalDataType["NetflixTitles"] = "netflixTitles";
    GlobalDataType["Netflix"] = "netflix";
    GlobalDataType["RenewableEnergyProduction"] = "renewableEnergyProduction";
    GlobalDataType["PredictCOVID_19Deaths"] = "predictCOVID-19Deaths";
    GlobalDataType["MarketingCampaignTargetCustomer"] = "marketingCampaignTargetCustomer";
    GlobalDataType["SalesForecast"] = "salesForecast";
    GlobalDataType["VehicleTransactions"] = "vehicleTransactions";
    GlobalDataType["TelecommunicationsCustomers"] = "telecommunicationsCustomers";
    GlobalDataType["OnlineRetailTransactions"] = "onlineRetailTransactions";
    GlobalDataType["SalesOpportunities"] = "salesOpportunities";
    GlobalDataType["SalesForecasting"] = "salesForecasting";
    GlobalDataType["CRMData"] = "crmData";
    GlobalDataType["ZoomInfoData"] = "zoomInfoData";
    GlobalDataType["WholesaleInvoice"] = "wholesaleInvoice";
    GlobalDataType["WholesaleProducts"] = "wholesaleProducts";
    GlobalDataType["DynamicDashboard"] = "dynamicDashboard";
    GlobalDataType["FinancialStatement"] = "financialStatement";
    GlobalDataType["GamificationChallenge01"] = "gamification01";
    GlobalDataType["ForecastingSolutions"] = "forecastingSolutions";
})(GlobalDataType || (GlobalDataType = {}));
export const DeprecatedGlobalDataTypes = [
    GlobalDataType.SellerCapacityPerformance,
    GlobalDataType.DiscountingDiagnosticsOverall,
    GlobalDataType.DiscountingDiagnostics0_1000,
    GlobalDataType.DiscountingDiagnostics1001_5000,
    GlobalDataType.OrderValidationOrders,
    GlobalDataType.OrderValidationValidOrders,
    GlobalDataType.OrderValidationTransactions
];
// eslint-disable-next-line consistent-return
export const GlobalDataTypeLatestVersion = (gdt) => {
    // eslint-disable-next-line default-case
    switch (gdt) {
        case GlobalDataType.NetflixTitles:
        case GlobalDataType.RosterValidationICM:
        case GlobalDataType.RosterValidationSP:
        case GlobalDataType.OrderValidationOrders:
        case GlobalDataType.OrderValidationValidOrders:
        case GlobalDataType.OrderValidationTransactions:
        case GlobalDataType.OrderConsolidationOrders:
        case GlobalDataType.OrderConsolidationValidOrders:
        case GlobalDataType.RecordAndAdjustmentCurrentPeriodTransactions:
        case GlobalDataType.RecordAndAdjustmentPriorPeriodTransactions:
        case GlobalDataType.IdentifyNewHiresAllEmployees:
        case GlobalDataType.IdentifyNewHiresNewHires:
        case GlobalDataType.TrackTerritoryChangesCurrentCycle:
        case GlobalDataType.TrackTerritoryChangesPreviousCycle:
        case GlobalDataType.TransactionReconciliationBillingData:
        case GlobalDataType.TransactionReconciliationOrders:
        case GlobalDataType.TransactionValidationTransactions:
        case GlobalDataType.EntityResolutionAccountLookup:
        case GlobalDataType.EntityResolutionTransactions:
        case GlobalDataType.HierarchyCreationAccountList:
        case GlobalDataType.HierarchyCreationUSStatesCode:
        case GlobalDataType.HierarchyValidatorCustomerAccounts:
        case GlobalDataType.SalesForecasting:
        case GlobalDataType.CRMData:
        case GlobalDataType.ZoomInfoData:
        case GlobalDataType.WholesaleInvoice:
        case GlobalDataType.WholesaleProducts:
        case GlobalDataType.DynamicDashboard:
        case GlobalDataType.FinancialStatement:
        case GlobalDataType.Netflix:
        case GlobalDataType.RenewableEnergyProduction:
        case GlobalDataType.PredictCOVID_19Deaths:
        case GlobalDataType.MarketingCampaignTargetCustomer:
        case GlobalDataType.SalesForecast:
        case GlobalDataType.VehicleTransactions:
        case GlobalDataType.TelecommunicationsCustomers:
        case GlobalDataType.OnlineRetailTransactions:
        case GlobalDataType.GamificationChallenge01:
            return 1;
        case GlobalDataType.Commissions:
        case GlobalDataType.Payouts:
        case GlobalDataType.SampleCustomers:
        case GlobalDataType.Transactions:
        case GlobalDataType.SellerPerformance:
        case GlobalDataType.GenderPay:
        case GlobalDataType.SellerChurn:
        case GlobalDataType.SellerChurnTest:
        case GlobalDataType.ForecastingSolutions:
        case GlobalDataType.LeadScoring:
        case GlobalDataType.SellerCapacity:
        case GlobalDataType.SellerCapacityPerformance:
        case GlobalDataType.SmartMatcherTransactionsTrain:
        case GlobalDataType.SmartMatcherLookupTrain:
        case GlobalDataType.SmartMatcherTransactionsTest:
        case GlobalDataType.SmartMatcherLookupTest:
        case GlobalDataType.Benchmarking:
        case GlobalDataType.OneColumnOneRow:
        case GlobalDataType.CombinationMatcherData:
        case GlobalDataType.CombinationMatcherValidCombination:
        case GlobalDataType.FinancialAdvisorTurnoverTrain:
        case GlobalDataType.FinancialAdvisorTurnoverTest:
        case GlobalDataType.CustomerLifetimeValueSMBRevenue:
        case GlobalDataType.CustomerLifetimeValueMMRevenue:
        case GlobalDataType.CustomerLifetimeValueEnterpriseRevenue:
        case GlobalDataType.DealValueChangesCRMOpportunities:
        case GlobalDataType.DiscountingDiagnosticsOrders:
        case GlobalDataType.DiscountingDiagnosticsIndustryBenchmarks:
        case GlobalDataType.DiscountingDiagnosticsDealSizeBenchmarks:
        case GlobalDataType.ASC606PrepBaseCommission:
        case GlobalDataType.ASC606PrepTransactionCredits:
        case GlobalDataType.ASC606PrepTransactionMaster:
        case GlobalDataType.ASC606TransactionalCommissions:
        case GlobalDataType.ASC606DateString:
        case GlobalDataType.ASC606AmortizationSetup:
        case GlobalDataType.OpportunityScores:
        case GlobalDataType.DiscountingDiagnosticsOverall:
        case GlobalDataType.DiscountingDiagnostics0_1000:
        case GlobalDataType.DiscountingDiagnostics1001_5000:
        case GlobalDataType.FuzzyMatcherCustomerLookup:
        case GlobalDataType.FuzzyMatcherSurveyResults:
        case GlobalDataType.SalesOpportunities:
            return 2;
        case GlobalDataType.Adjustments:
        case GlobalDataType.HotelBookings:
        case GlobalDataType.Forecasting:
            return 3;
        case GlobalDataType.DiversityCandidates:
        case GlobalDataType.Diversity:
            return 4;
    }
};
const GlobalImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:GlobalImportConfig',
    type: 'object',
    properties: {
        globalDataType: {
            type: 'string',
            enum: Object.values(GlobalDataType)
        },
        version: { type: 'integer', minimum: 1 }
    },
    required: ['globalDataType', 'version']
};
let GlobalImportConfig = GlobalImportConfig_1 = class GlobalImportConfig extends ImportConfig {
    constructor(type, version, columnsToUpdate) {
        super(ImportConfigType.Global, columnsToUpdate);
        this.globalDataType = type;
        this.version = version;
        JSON.validate(this, GlobalImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [];
    }
    get needsDiscovery() {
        return false;
    }
};
GlobalImportConfig = GlobalImportConfig_1 = __decorate([
    JsonSchema(GlobalImportConfigSchema),
    JsonDiscriminatorValue(ImportConfigType.Global)
], GlobalImportConfig);
export { GlobalImportConfig };
(function (GlobalImportConfig) {
    function parseGlobalType(type) {
        for (const key in GlobalDataType) {
            if (GlobalDataType[key] === type) {
                return GlobalDataType[key];
            }
        }
        return undefined;
    }
    GlobalImportConfig.parseGlobalType = parseGlobalType;
})(GlobalImportConfig || (GlobalImportConfig = {}));
//# sourceMappingURL=globalImportConfig.js.map